import React                  from 'react';
import classnames             from 'classnames';
import { FontAwesomeIcon }    from '@fortawesome/react-fontawesome';

import IconUnknownMountingType   from 'images/bom/unknown-mounting-type.png'

const PartMountingTypeSelector = (props) => {
  var default_value = ""
  if (props.mounting_type_entered){
    default_value = props.mounting_type_entered
  }
  return (
    <div className="d-flex align-items-center">
      {default_value === "" && 
        <img className="icon-bom-admin" src={IconUnknownMountingType} alt="Icon bom admin" />
      }
      <select className="form-control form-control-sm mounting-type-selector" 
       defaultValue={default_value} 
       onChange={e => props.onChangeMountingType(props.offer_id, e.target.value)} >
        <option value="">Make Selection</option>
        <option value="SMT">SMT</option>
        <option value="QFN">QFN</option>
        <option value="BGA">BGA</option>
        <option value="THT">THT</option>
      </select>
    </div>
  )
}

export default PartMountingTypeSelector;